/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Tag Category create input
 * @export
 * @interface TagCategoryCreateModel
 */
export interface TagCategoryCreateModel {
    /**
     * 
     * @type {string}
     * @memberof TagCategoryCreateModel
     */
    name: string;
    /**
     * 
     * @type {{ [key: string]: object; }}
     * @memberof TagCategoryCreateModel
     */
    settings: { [key: string]: object; };
    /**
     * 
     * @type {Array<number>}
     * @memberof TagCategoryCreateModel
     */
    assetTypeIds: Array<number>;
}

export function TagCategoryCreateModelFromJSON(json: any): TagCategoryCreateModel {
    return TagCategoryCreateModelFromJSONTyped(json, false);
}

export function TagCategoryCreateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TagCategoryCreateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'settings': json['settings'],
        'assetTypeIds': json['assetTypeIds'],
    };
}

export function TagCategoryCreateModelToJSON(value?: TagCategoryCreateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'settings': value.settings,
        'assetTypeIds': value.assetTypeIds,
    };
}


